// Tailwind classes shared by the legend and the 3D scene, which reads its colors from them,
// so both stay in sync and follow light/dark mode.
export const SLACK_CONNECTED_CLASS = "bg-emerald-500 dark:bg-emerald-400";
export const SLACK_NOT_CONNECTED_CLASS = "bg-rose-500 dark:bg-rose-400";
export const INCIDENT_ALERT_CLASS = "bg-amber-500 dark:bg-amber-400";
export const INCIDENT_TIMER_CLASS = "bg-zinc-900 dark:bg-zinc-700";
export const INCIDENT_OVERDUE_CLASS = "bg-red-600 dark:bg-red-500";
export const SEAT_SELECTABLE_CLASS = "bg-sky-500 dark:bg-sky-400";
